import Input from '../../../Interfaces/Requests/Reports/Input';
import { filterInputArrayToIdArray, filterInputArrayToValueArray } from '../../../Utils/ConverterUtil';
import ChartParameters from '../../../Interfaces/Chart/ChartParameters';
import DataSetParameters from '../../../Interfaces/DataSet/DataSetParameters';
import ItemIdMap from '../../../Interfaces/Reports/ItemIdMap';
import InputMaps from '../../../Interfaces/Reports/InputMaps';
import { FilterInput } from '../../../Interfaces/Responses/Dashboard/FilterInput';
import PassthroughInputMap from '../../../Interfaces/Responses/Reports/Charts/PassthroughInputMap';

export function loadPassthroughInputMaps (itemIdMap: ItemIdMap | undefined, dataSetParameters: DataSetParameters) : PassthroughInputMap[]
{
    const passthroughInputMaps: PassthroughInputMap[] = [];

    itemIdMap?.filterInputs.forEach(eachFilterInput => {
        const passthroughInputMap: PassthroughInputMap = {
            reportInputTitle: eachFilterInput.input.title,
            reportInputID: eachFilterInput.input.id,
            inputID: 0,
            datasetInputIDs: [],
            datasetInputID: 0,
            inputValue: eachFilterInput.hasValue ? eachFilterInput.value : '',
        };

        passthroughInputMaps.push(passthroughInputMap);
    });

    itemIdMap?.inputMaps.forEach(eachInputMap1 => {
        eachInputMap1.inputMaps.forEach(eachInputMap2 => {
            const passthroughInputMap = passthroughInputMaps.find((x) => x.reportInputID === eachInputMap2.inputID);
            if (passthroughInputMap)
            {
                passthroughInputMap.datasetInputIDs.push(eachInputMap2.datasetInputID);
            }
        })
    });

    let keyDataSetInputIDFound = false;
    if (dataSetParameters.drilldowns && (dataSetParameters.drilldowns?.length > 0)) {
        let drilldown = dataSetParameters.drilldowns[0];

        passthroughInputMaps.forEach((eachPassthroughInputMap1 => {
            const datasetInputID1 = eachPassthroughInputMap1.datasetInputIDs.find((x) => x === drilldown.dataSetInputID);

            if ((datasetInputID1 === undefined) && (keyDataSetInputIDFound === false)) {
                const passthroughInputMap1: PassthroughInputMap = {
                    reportInputTitle: drilldown.sourceValue,
                    reportInputID: 0,
                    inputID: 0,
                    datasetInputIDs: [],
                    datasetInputID: 0,
                    inputValue: dataSetParameters.drilldownData ?? '',
                };
                passthroughInputMap1.datasetInputIDs.push(drilldown.dataSetInputID);
                passthroughInputMaps.push(passthroughInputMap1);

                keyDataSetInputIDFound = true;
            }
        }));

        if (drilldown.passthroughInputMaps.length > 0) {
            drilldown.passthroughInputMaps.forEach((eachPassthroughInputMap2 => {
                passthroughInputMaps.forEach((eachPassthroughInputMapX => {
                    let inputID = eachPassthroughInputMapX.datasetInputIDs.find((x) => x === eachPassthroughInputMap2.inputID);

                    if (inputID !== undefined) {
                        eachPassthroughInputMapX.datasetInputIDs.push(eachPassthroughInputMap2.datasetInputID);
                    }
                }))
            }));
        }
    };

    return passthroughInputMaps;
}

/*export function loadPassthroughInputMaps (itemIdMap: ItemIdMap | undefined, dataSets: ServaDBChartDataSet[]) : PassthroughInputMap[]
{
    const passthroughInputMaps: PassthroughInputMap[] = [];

    itemIdMap?.filterInputs.forEach(eachFilterInput => {
        const passthroughInputMap: PassthroughInputMap = {
            reportInputTitle: eachFilterInput.input.title,
            reportInputID: eachFilterInput.input.id,
            inputID: 0,
            datasetInputIDs: [],
            datasetInputID: 0,
            inputValue: eachFilterInput.hasValue ? eachFilterInput.value : '',
        };

        passthroughInputMaps.push(passthroughInputMap);
    });

    itemIdMap?.inputMaps.forEach(eachInputMap1 => {
        eachInputMap1.inputMaps.forEach(eachInputMap2 => {
            const passthroughInputMap = passthroughInputMaps.find((x) => x.reportInputID === eachInputMap2.inputID);
            if (passthroughInputMap)
            {
                passthroughInputMap.datasetInputIDs.push(eachInputMap2.datasetInputID);
            }
        })
    });

    let keyDataSetInputIDFound = false;
    dataSets.forEach((eachDataSet: ServaDBChartDataSet) => {
        if (eachDataSet.drilldowns.length > 0) {
            passthroughInputMaps.forEach((eachPassthroughInputMap1 => {
                const datasetInputID1 = eachPassthroughInputMap1.datasetInputIDs.find((x) => x === eachDataSet.drilldowns[0].dataSetInputID);

                if ((datasetInputID1 === undefined) && (keyDataSetInputIDFound === false)) {
                    const passthroughInputMap1: PassthroughInputMap = {
                        reportInputTitle: eachDataSet.drilldowns[0].sourceValue,
                        reportInputID: 0,
                        inputID: 0,
                        datasetInputIDs: [],
                        datasetInputID: 0,
                        inputValue: '',
                    };
                    passthroughInputMap1.datasetInputIDs.push(eachDataSet.drilldowns[0].dataSetInputID);
                    passthroughInputMaps.push(passthroughInputMap1);

                    keyDataSetInputIDFound = true;
                }
            }));

            if (eachDataSet.drilldowns[0].passthroughInputMaps.length > 0) {
                eachDataSet.drilldowns[0].passthroughInputMaps.forEach((eachPassthroughInputMap2 => {
                    passthroughInputMaps.forEach((eachPassthroughInputMapX => {
                        let inputID = eachPassthroughInputMapX.datasetInputIDs.find((x) => x === eachPassthroughInputMap2.inputID);

                        if (inputID !== undefined) {
                            eachPassthroughInputMapX.datasetInputIDs.push(eachPassthroughInputMap2.datasetInputID);
                        }
                    }))
                }));
            }
        }
    });

    return passthroughInputMaps;
}*/

export function populateChartInputs(
    chartParameters: ChartParameters | undefined,
    inputMapsArray: InputMaps[],
    filterInputs: FilterInput[]
): Input[] {
    const inputs: Input[] = [];
    if (!chartParameters) return [];
    const inputMaps = inputMapsArray.find(
        (eachInputMap) => eachInputMap.objectId === chartParameters.chartId
    );
    const filterIds = chartParameters.isDrillDown
        ? ['', chartParameters.chartId.toString()]
        : filterInputArrayToIdArray(filterInputs);
    filterIds.forEach((eachFilterIdInput) => {
        const input: Input = {
            key:
                inputMaps?.inputMaps
                    .find(
                        (eachInputMap) =>
                            eachInputMap.inputID.toString() ===
                            eachFilterIdInput
                    )
                    ?.datasetInputID.toString() ?? '',
            value: '',
        };
        inputs.push(input);
    });
    const values = chartParameters.isDrillDown
        ? ['', chartParameters.drilldownData ?? '']
        : filterInputArrayToValueArray(filterInputs);
    for (let i = 0; i < inputs.length; i++) {
        inputs[i].value = values[i];
    }
    return inputs;
}

export function populateDataSetInputs(
    dataSetParameters: DataSetParameters | undefined,
    inputMapsArray: InputMaps[],
    filterInputs: FilterInput[]
): Input[] {
    const inputs: Input[] = [];
    if (!dataSetParameters) return [];
    const inputMaps = inputMapsArray.find(
        (eachInputMap) => eachInputMap.objectId === dataSetParameters.dataSetId
    );
    const filterIds = dataSetParameters.isDrillDown
        ? ['', dataSetParameters.dataSetId.toString()]
        : filterInputArrayToIdArray(filterInputs);
    filterIds.forEach((eachFilterIdInput) => {
        const input: Input = {
            key:
                inputMaps?.inputMaps
                    .find(
                        (eachInputMap) =>
                            eachInputMap.inputID.toString() ===
                            eachFilterIdInput
                    )
                    ?.datasetInputID.toString() ?? '',
            value: '',
        };
        inputs.push(input);
    });
    const values = dataSetParameters.isDrillDown
        ? ['', dataSetParameters.drilldownData ?? '']
        : filterInputArrayToValueArray(filterInputs);
    for (let i = 0; i < inputs.length; i++) {
        inputs[i].value = values[i];
    }
    return inputs;
}

export function populateDrilldownDataSetInputs(
    passthroughInputMaps: PassthroughInputMap[]
): Input[] {
    const inputs: Input[] = [];

    if (!passthroughInputMaps) return [];

    passthroughInputMaps.forEach((eachPassthroughInputMap) => {
        eachPassthroughInputMap.datasetInputIDs.forEach(eachDatasetInputID => {
            const input: Input = {
                key: eachDatasetInputID.toString(),
                value: eachPassthroughInputMap.inputValue,
            };
            inputs.push(input);
        });
    });

    return inputs;
}
